import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Group } from "@mantine/core";
import { useAppAction, useAppSelector } from "../../hooks/redux.js";
import { getLayersListDisplay, setLayersDisplay } from "../../reducers/layersReducer.js";
import { useCallback } from "react";
import { useStyleEditor } from "../../components/StyleEditorContext.js";
import { Event } from "../../constants/events.js";
import { FormattedMessage } from "react-intl";
export const LayerListFooter = () => {
    const { captureEvent } = useStyleEditor();
    const currentDisplay = useAppSelector(getLayersListDisplay);
    const changeDisplay = useAppAction(setLayersDisplay);
    const handleChangeDisplay = useCallback((display) => {
        captureEvent(Event.ChangeLayersListDisplay, {
            display,
        });
        changeDisplay(display);
    }, [changeDisplay, captureEvent]);
    return (_jsxs(Group, { gap: 8, children: [_jsx(Button, { flex: "1 0 0", variant: currentDisplay === "ordered" ? "filled" : "light", color: currentDisplay === "ordered" ? "dark" : "black", c: currentDisplay === "ordered" ? "white" : "gray", radius: 6, onClick: () => {
                    handleChangeDisplay("ordered");
                }, children: _jsx(FormattedMessage, { id: "button.ordered", defaultMessage: "Ordered" }) }), _jsx(Button, { flex: "1 0 0", variant: currentDisplay === "grouped" ? "filled" : "light", color: currentDisplay === "grouped" ? "dark" : "gray", c: currentDisplay === "grouped" ? "white" : "gray", radius: 6, onClick: () => {
                    handleChangeDisplay("grouped");
                }, children: _jsx(FormattedMessage, { id: "button.grouped", defaultMessage: "Grouped" }) })] }));
};
